import { SetStateAction, useState } from "react";

import { useDrawerStore } from "@/stores/useDrawerStore";
import { useTableStoreByRoute } from "@/stores/useTableStore";

import { MenuAnchorEl, ROUTES, useMediaQueries } from "../../../shared";

export const useFilters = (route: ROUTES) => {
  const { fromLg, toLg, toMd, fromMd } = useMediaQueries();

  const {
    params: { desktopDetailsSection }
  } = useTableStoreByRoute(route);
  const { isDesktopDrawerOpen } = useDrawerStore();

  const [anchorEl, setAnchorEl] = useState<MenuAnchorEl>(null);

  const handleOpenMenu = (e: {
    currentTarget: SetStateAction<MenuAnchorEl>;
  }) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseMenu = () => setAnchorEl(null);

  const isPartOfFilterMenu = () => {
    return toLg || (fromLg && desktopDetailsSection && isDesktopDrawerOpen);
  };

  const isPartOfFilesFilterMenu = () => {
    return toMd || (fromMd && desktopDetailsSection && isDesktopDrawerOpen);
  };

  return {
    anchorEl,
    handleOpenMenu,
    handleCloseMenu,
    isPartOfFilterMenu,
    isPartOfFilesFilterMenu
  };
};
